<template>
    <date-picker
        :value="value"
        :config="options"
        @dp-change="$emit('input', $event.target.value)"
        class="form-control form-control-sm"
        >
    </date-picker>
</template>

<script>
// Import required dependencies 
import 'bootstrap/dist/css/bootstrap.css';

// Import this component
import datePicker from 'vue-bootstrap-datetimepicker';

// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {    
    props: [
        'value'
    ],
    data () {
        return {
            options: {
                format: 'YYYY-MM-DD HH:mm:ss',
                useCurrent: false,
                showClear: true,
                showClose: true,
//                keyBinds: {
//                    up (widget) {},
//                    down (widget) {},
//                    left (widget) {},
//                    right (widget) {},
//                },
            }       
        }
    },
    components: {
        datePicker
    }
}
</script>
